import { Directive, ElementRef, Renderer2, Input } from '@angular/core';
import { Constants } from '../constants';
import { isNullOrUndefined } from 'util';
import {LocalStorageService} from 'src/app/shared/services/local-storage.service';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { AuthorizationService } from 'src/app/core/services/authorization/authorization.service';
@Directive({
    selector: '[appDisableUnauthorized]',
    standalone: false
})
export class DisableUnauthorizedDirective {
  @Input('appDisableUnauthorized') controlKey: string;
  constructor(
    private el: ElementRef, private renderer2: Renderer2,
    private authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
    private authorizationService: AuthorizationService) {
    this.checkControlAuthorization(this.controlKey);
  }

  private setControlDisable(isAuthorized: boolean) {
    if (!isAuthorized) {
      this.el.nativeElement.disabled = 'disabled';
      this.renderer2.addClass(this.el.nativeElement, 'disable-ctrl');
      this.el.nativeElement.style.color = '#dddddd';
    }
  }

  private checkControlAuthorization(controlKey: string) {
    let isAuthorized = false;
    const claims = this.authenticationService.GetClaims();
    // tslint:disable-next-line: no-string-literal
    if (claims !== null && claims !== undefined) {
      const extensionPrmissions = this.localStorageService.GetClaimsTransformed(claims.extension_permissions).map((item: string) => item.trim());
      let authorizedControlList = JSON.parse(this.localStorageService.getItem(Constants.AUTHORIZED_CONTROLS));
      if (isNullOrUndefined(authorizedControlList)) {
        this.authorizationService.getAuthorizedControlList().subscribe(data => {
          this.localStorageService.setItem(Constants.AUTHORIZED_CONTROLS, JSON.stringify(data));
          authorizedControlList = JSON.parse(this.localStorageService.getItem(Constants.AUTHORIZED_CONTROLS));
          isAuthorized = this.isControlAuthorized(authorizedControlList, controlKey, extensionPrmissions);
          this.setControlDisable(isAuthorized);
        });
      } else {
        isAuthorized = this.isControlAuthorized(authorizedControlList, controlKey, extensionPrmissions);
        this.setControlDisable(isAuthorized);
      }
    }

  }

  private isControlAuthorized(authorizedControlList: any, controlKey: string, extensionPrmissions: any): boolean {
    let value = false;
    if (!isNullOrUndefined(authorizedControlList)) {
      authorizedControlList.forEach((element: { key: string; groups: string; }) => {
        if (element.key === controlKey) {
          const groups = element.groups.split(',');
          groups.forEach((claimGroup: any) => {
            extensionPrmissions.forEach((permission: any) => {
              if (permission === claimGroup) {
                value = true;
              }
            });
          });
        }
      });
    }
    return value;
  }
}
